export default "__VITE_ASSET__VTfQG8uP__"